// extracted by mini-css-extract-plugin
export default {"title":"PbuzAF_MAeQj_FjS8Xbv","table":"qCCUK31FEigbCNyy6hGy","button":"HkR4xxyyynNJE_asiaf1","loader":"hNnmloRKZlk_TJ_9hcup"};